import script from "./BusinessDescriptionStep.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessDescriptionStep.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__